module.exports = __webpack_public_path__ + "img/mb7.77ce1d22.png";